import { Heart, MessageCircle, Send, Bookmark } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { SOCIAL } from "@/data/site";
import { Reveal, StaggerItem } from "@/components/Reveal";

const SocialMockups = () => {
  const { t, tr } = useLang();
  return (
    <section id="social" className="bg-cream border-b border-ink py-20 md:py-28 scroll-mt-24" data-testid="social">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <p className="kicker text-pink">{t.socialKicker}</p>
            <h2 className="display uppercase text-5xl md:text-7xl leading-[0.85] mt-3 max-w-3xl text-brand">{t.socialTitle}</h2>
          </div>
          <p className="max-w-sm text-lg font-medium text-ink/70">{t.socialSub}</p>
        </Reveal>

        <StaggerItem className="mt-12">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink border border-ink">
            {SOCIAL.map((post, i) => (
              <article key={i} className="bg-cream" data-testid={`social-post-${i}`}>
                <div className="flex items-center gap-2.5 p-3.5 border-b border-ink">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-lilac to-pink border border-ink" />
                  <span className="font-semibold text-sm">{post.handle}</span>
                  <span className="ml-auto kicker text-[10px] bg-lime px-2 py-0.5 border border-ink rounded-full">{tr(post.setting)}</span>
                </div>
                <div className="relative aspect-[4/5] bg-sand overflow-hidden group">
                  <img
                    src={post.image}
                    alt={tr(post.setting)}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                </div>
                <div className="p-3.5">
                  <div className="flex items-center gap-4">
                    <Heart className="w-5 h-5 text-pink fill-pink" strokeWidth={2} />
                    <MessageCircle className="w-5 h-5" strokeWidth={2} />
                    <Send className="w-5 h-5" strokeWidth={2} />
                    <Bookmark className="w-5 h-5 ml-auto" strokeWidth={2} />
                  </div>
                  <p className="font-bold text-sm mt-2.5">{post.likes} Likes</p>
                  <p className="text-sm mt-1"><span className="font-bold">{post.handle}</span> {tr(post.caption)}</p>
                </div>
              </article>
            ))}
          </div>
        </StaggerItem>
      </div>
    </section>
  );
};

export default SocialMockups;
